import { faker } from '@faker-js/faker'

import { DEFAULT_V2_SITE_ID } from '../../constants/tests.constants'

export const CLIENT_MOCK = {
  id: faker.database.mongodbObjectId(),
  firstName: faker.person.firstName(),
  v1Id: faker.number.int(),
  email: faker.internet.email(),
  lastName: faker.person.lastName(),
  birthday: faker.date.future().toISOString(),
  barcode: faker.string.uuid(),
  gender: faker.person.sex(),
  siteNotes: [
    {
      siteId: faker.database.mongodbObjectId(),
    },
    {
      siteId: faker.database.mongodbObjectId(),
    },
  ],
  siteAlertedProperties: [
    {
      siteId: faker.database.mongodbObjectId(),
    },
    {
      siteId: faker.database.mongodbObjectId(),
    },
  ],
  profileImage: {
    url: faker.image.avatar(),
  },
  formsPending: [
    {
      siteId: faker.database.mongodbObjectId(),
      title: 'Initiation form',
    },
    {
      siteId: DEFAULT_V2_SITE_ID,
      title: 'Initiation form',
    },
  ],
  homeSites: new Array(10).fill().map((_) => faker.person.jobArea()),
}
